import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CanvasComponent } from './_canvas/canvas.component';
import { HeaderComponent } from './_canvas/header/header.component';
import { MainComponent } from './_canvas/main/main.component';
import { FooterComponent } from './_canvas/footer/footer.component';
import { RouterModule } from '@angular/router';
import { CanActivateViaAuthGuard } from './services/auth.guard';
import { NgxSpinnerModule } from 'ngx-spinner';
@NgModule({
  declarations: [CanvasComponent, HeaderComponent, MainComponent, FooterComponent],
  imports: [
    CommonModule, RouterModule,
    NgxSpinnerModule
  ],
  exports: [CanvasComponent],
  providers: [CanActivateViaAuthGuard]
})
export class CoreModule { }
